import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from './style';
import SearchBar from '../../../components/SearchBar';
import LocationOwnersTable from './LocationOwnersTable';
import { Box } from '@mui/material';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../../constants/pagination';
import FILTER_CONSTANTS from '../../../constants/FilterConstants';
import { useSearchFilterParam } from '../../../hooks';
import { setActiveLocationOwnerFilters } from '../../../redux-slice/locationOwnerFilters';

const { FILTER_DATA } = FILTER_CONSTANTS;
const filterKey = FILTER_DATA.LOCATION_OWNER;

const ActiveTab = (props) => {
  const { onTotalLocationOwnersCount } = props;
  const [searchText, setSearchText] = useState('');

  const classes = useStyles();
  const dispatch = useDispatch();
  const { activeLocationOwner } = useSelector((state) => state.locationOwnerFilter);

  useEffect(() => {
    setSearchText(activeLocationOwner.searchText);
  }, [activeLocationOwner]);

  const searchParams = useSearchFilterParam({
    filterKey,
    searchText,
  });

  const searchHandler = (params) => {
    setSearchText(params);
    dispatch(
      setActiveLocationOwnerFilters({
        ...activeLocationOwner,
        searchText: params,
        pageNumber: DEFAULT_PAGE,
        rowsPerPage: DEFAULT_PER_PAGE,
      }),
    );
  };

  const onReset = () => {
    setSearchText('');
    dispatch(
      setActiveLocationOwnerFilters({
        ...activeLocationOwner,
        searchText: '',
        pageNumber: DEFAULT_PAGE,
        rowsPerPage: DEFAULT_PER_PAGE,
      }),
    );
  };

  return (
    <>
      <Box className={classes.searchFilterWrap}>
        <Box className={classes.searchWrap}>
          <SearchBar
            placeholder="Search location Owners"
            onSearch={searchHandler}
            onReset={onReset}
            searchText={searchText}
          />
        </Box>
      </Box>
      <LocationOwnersTable
        searchParams={searchParams}
        onTotalLocationOwner={onTotalLocationOwnersCount}
        tab="active"
        activeLocationOwner={activeLocationOwner}
      />
    </>
  );
};

export default ActiveTab;
